(ns kyber.subscriptions.async-request
  (:require [re-frame.core :as re-frame]))

;; These subscriptions are for tracking the state of our eql async requests.
;; See `lambda.pathom.process-tx-async` for how async eql requests are handled in the backend.

(defn is-polling-complete?
  [db [_ request-key]]
  (some? (get (:polling-complete db) request-key)))

(defn is-polling?
  [db [_ request-key]]
  (some? (get (:polling-in-progress db) request-key)))

(defn initialize []
  (re-frame/reg-sub ::is-polling-complete? is-polling-complete?)
  (re-frame/reg-sub ::is-polling? is-polling?))
